<template>
  <div>
    <!-- 头部整体盒子 -->
    <div id="header" class="container-fuild">
      <!-- 电脑导航 -->
      <div
        class="header-nav header-nav-m hidden-xs"
        mode="horizontal"
        :ellipsis="false"
      >
        <div class="header-box">
          <div class="header-logo">
            <img
              class="logo-img"
              @click="$router.push('/')"
              :src="require('@/assets/img/home/LOGO.svg')"
            />
            <div class="header-menu">
              <div class="box">
                <div
                  class="menu-item"
                  @click="goPath(item, i)"
                  v-for="(item, i) in navList"
                  :key="i"
                  :class="{ 'is-active': isActive === i }"
                >
                  <span
                    class="menu-item-cd"
                    v-if="item.children.length <= 0 || item.path === '/about'"
                    >{{ item.name }}</span
                  >
                  <el-dropdown class="menu-item-cd" v-else>
                    <span class="menu-item-cd-item">
                      {{ item.name }}
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu class="dropdown-box">
                        <el-dropdown-item
                          v-for="(cd, k) in item.children"
                          :key="k"
                          @click="goPageHasList(item.path + cd.path)"
                          class="dropdown-item"
                          style=""
                        >
                          <div class="dot"></div>
                          <div class="name">{{ cd.name }}</div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <el-link
                  href="https://www.elinkht.com/#/hall/index"
                  target="_blank"
                  class="menu-item platform-home"
                  ><el-icon class="platform-home-icon"><Promotion /></el-icon
                  >平台入口</el-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 移到端导航 -->
      <div class="header-nav visible-xs">
        <img
          @click="$router.replace('/home')"
          class="logo-img"
          :src="require('@/assets/img/home/LOGO.svg')"
        />

        <el-icon
          @click="showMenuList()"
          class="menu-icon"
          size="large"
          :class="{ rotated: showMenu }"
          ><Menu
        /></el-icon>
      </div>
      <el-collapse-transition
        style="background-color: #242632; position: fixed; z-index: 9999"
      >
        <el-menu unique-opened style="width: 100%" v-show="showMenu" router>
          <template v-for="(me, i) in navList" :key="i">
            <el-menu-item
              @click="showMenuList()"
              :index="me.path"
              v-if="me.children.length <= 0"
            >
              <span>{{ me.name }}</span>
            </el-menu-item>
            <el-sub-menu :index="me.path" v-else>
              <template #title
                ><span>{{ me.name }}</span></template
              >
              <el-menu-item
                @click="showMenuList()"
                v-for="(mc, j) in me.children"
                :key="j"
                :index="mc.path"
                :route="me.path + mc.path"
                >{{ mc.name }}</el-menu-item
              >
            </el-sub-menu>
          </template>
          <el-menu-item @click="showMenuList()">
            <el-link
              href="https://www.elinkht.com/#/hall/index"
              target="_blank"
              icon="Promotion"
              ><span>平台入口</span></el-link
            >
          </el-menu-item>
        </el-menu>
      </el-collapse-transition>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  props: {
    navList: {
      required: true,
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      //绑定激活样式
      isActive: 0,

      animated: false,
      isScrolled: false,
      show: false,
      currentPath: "/",
      currentData: [],
      showMenu: false,
      isShowMenuItems: false,
      activeIndex: -1,

      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
    };
  },

  // mounted() {
  //   // 在组件挂载时添加滚动事件监听器
  //   window.addEventListener('scroll', this.handleScroll)
  // },
  // beforeUnmount() {
  //   // 在组件卸载前移除滚动事件监听器
  //   window.removeEventListener('scroll', this.handleScroll)
  // },

  created() {
    // this.isActive = this.navList.findIndex(
    //   (item) =>
    //     this.$route.path === item.path || this.$route.path.includes(item.path)
    // );
  },

  watch: {
    // 监听路由的变化
    $route(to, from) {
      this.isActive = this.navList.findIndex(
        (item) => to.path === item.path || to.path.includes(item.path)
      );
    },
  },

  methods: {
    // 新方法
    goPath(item, i) {
      this.isActive = i;
      if (item.children.length > 0 && item.path != "/about") {
        this.$router.push(`${item.path}${item.children[0].path}`);
        return;
      }
      this.$router.push(item.path);
    },

    // 新方法
    goPageHasList(path) {
      this.$router.replace(path);
    },
    goPage(nl) {
      if (!nl.children.length > 0 || nl.path === "/about") {
        this.$router.push(nl.path);
        return;
      }
      const root = nl.children[0];
      if (nl.path === "/elinkht") {
        this.$router.push(nl.path + root.path + root.children[0].path);
        return;
      }
      this.$router.push(nl.path + root.path);
    },

    handleScroll() {
      this.isScrolled = window.pageYOffset > 0;
    },
    showMenuList() {
      this.showMenu = !this.showMenu;
    },
    showMenuItems(index) {
      this.isShowMenuItems = !this.isShowMenuItems;
      this.activeIndex = index;
    },

    showHiddenDiv(path) {
      this.animated = true;
      this.show = true;
      this.currentPath = path;
      this.currentData = this.navList.filter((i) => i.path === path)[0];
    },
    hideHiddenDiv() {
      this.show = false;
    },
    navClick(index, name) {
      this.show = false;
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
  },
};
</script>
<style scoped lang="less">
::v-deep(:focus-visible) {
  outline: none;
}
// /deep/ .el-popper[data-popper-placement^=bottom]>.el-popper__arrow {
//   display: none !important;
// }
// ::v-deep
//   .el-popper[data-popper-placement^="bottom"]
//   > .el-popper-arrow::before {
//   border-top-left-radius: 0;
// }

/deep/ .el-dropdown-menu__item:not(.is-disabled) {
  // color: #ffffff;
  background: none !important;
  &:hover {
    color: #075ffc;
    /deep/ .el-dropdown-item.is-active {
      background-color: #ffffff;
    }
  }
}
/deep/ .el-dropdown-menu__item:first-child {
  border: none !important;
}

// ::v-deep .el-dropdown-menu__item:not(.is-disabled):focus {
//   background: #1e2328;
//   color: #ffffff;
// }
// ::v-deep .el-dropdown-menu {
//   padding: 0 !important;
//   background: #1e2328 !important;
// }

/* 顶部 */
#header {
  &.scrolled,
  &:hover {
    background: #1e2328;
  }
}

/* 导航栏 */
::v-deep .el-dropdown__popper.el-popper,.el-popper.is-light{
  border: none !important;
}
::v-deep .dropdown-item {
  padding-bottom: 16px !important;
  padding-top: 16px !important;
  border-top: 1px solid #f1f3f5 !important;
  width: 154px !important;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #1e2328 !important;
  
  .name {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #1e2328;
    line-height: 20px;
    &:hover {
    color: #075ffc !important;
  }
  }
}
#header .header-nav {
  width: 100%;
  height: 48px;
  border-bottom: 0px;
  // background-color: #242632;
  background: #1e2328;
  .header-box {
    width: 120rem;
    height: 100%;
    margin: auto;
    display: flex;
    position: relative;

    .header-logo {
      width: 15rem;
      height: 32px;
      .logo-img {
        cursor: pointer;
        padding: 8px 0 0 16px;
      }
      // margin: 0.8rem 1.9rem;
      // background-color: #ffffff;
    }

    .header-menu {
      position: absolute;
      top: 0;
      right: 0;
      width: 45rem;
      height: 100%;
      color: #ffffff;
      display: flex;
      // background-color: #ffffff;
      .box {
        position: absolute;
        right: 0;
        display: flex;

        .menu-item {
          height: 18px;
          font-size: 12px;
          height: 100%;
          margin: 15px 16px;
          font-weight: 400;
          cursor: pointer;
          .menu-item-cd {
            line-height: 1.42857143;
            font-size: 12px !important;
            background-color: #1e2328;
            color: #C8CBD2;
            .menu-item-cd-item.el-dropdown__caret {
              display: none; /* 隐藏箭头图标 */
            }
            &:hover {
              color: #ffffff;
              // font-weight: 500 !important;
            }
          }
        }
        .is-active {
          .menu-item-cd{
            color: #ffffff !important;
          }
          
          font-weight: 500 !important;
          border-bottom: 2px solid #ffffff;
          border-radius: 1px;
        }
        .platform-home {
          color: #C8CBD2;
          &:hover {
              color: #ffffff;
              // font-weight: 500 !important;
            }
          .platform-home-icon {
            width: 1.2rem;
            height: 1.2rem;
            margin-right: 0.2rem;
          }
        }
      }
    }
  }
}

.rotated {
  transform: rotate(45deg); /* 旋转90度 */
}
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #075ffc;
  margin-right: 16px;
}

.logo-box {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  margin-left: 30px;
  .logo-title {
    color: #ffffff;
    margin-left: 0.6rem;
    font-weight: bold;
  }
}

.header-nav-logo {
  width: 53px;
  height: 50px;
}

/* 菜单名称样式 */
.menu-name {
  color: #ffffff;
  font-size: 18px;
}

.el-link {
  font-size: 15px;
  margin-right: 2rem;
  --el-link-hover-text-color: none;
  text-decoration: none !important;
}

@media screen and(max-width: 1200px) {
  #header .header-nav {
    .header-box {
      width: 100%;
    }
  }
}

@media screen and (max-width: 900px) {
  /* pc端导航栏 */
  /* .flex-grow {
  flex-grow: 4;
} */
  .menu-name {
    font-size: 8px;
  }
  ::v-deep .el-menu-item {
    padding: 0 8px;
  }
  ::v-deep .el-sub-menu__title {
    padding: 0 18px 0 8px;
  }

  // ::v-deep .el-sub-menu__icon-arrow {
  //   margin-right: 16px;
  //   right: 6px !important;
  // }

  .el-link {
    color: #ffffff;
    font-size: 8px;
    margin-right: 1rem;
  }
  .header-nav {
    display: flex;
    position: relative;
    .logo-img {
      padding: 8px 0 0 16px;
    }
    .menu-icon {
      color: rgb(26, 115, 232);
      position: absolute;
      top: 30%;
      right: 10%;
    }
  }
  .logo-title {
    color: #ffffff;
    font-weight: bold;
    font-size: 18px;
  }
}
</style>

<style>
.el-popper {
  border: none !important;
  overflow: auto;
}

.el-dropdown-menu__item {
  line-height: 0px !important;
}
</style>